<template>
    <div id="product-mass-action-form">
        <b-loading :active="loading"></b-loading>
        <top-section>
            Product Mass Category Update
            <template v-slot:buttons>
                <b-button tag="button" v-if="checkedRows.length"
                          type="is-primary"
                          class="is-uppercase"
                          label="Update Products"
                          rounded @click.prevent="submit"
                          outlined></b-button>
            </template>
        </top-section>

        <div class="section" v-if="!checkedRows.length">
            <b-notification
                type="is-warning"
                has-icon :closable="false">
                <p class="mb-3">There are no products choosen for mass action. Please go back to the products page and select some products.</p>
                <b-button tag="router-link" :to="{name: 'product.index'}" type="is-black" label="Go to Products" outlined></b-button>
            </b-notification>
        </div>

        <div class="section" v-if="checkedRows.length">
            Updating category association for products: {{ productIds }}
        </div>

        <div class="section" v-if="checkedRows.length">
            <b-field horizontal label="Add Category">
                <b-taginput
                    :data="filteredCategories"
                    placeholder="Add a category"
                    field="name"
                    :allow-new="false"
                    autocomplete
                    open-on-focus @typing="getFilteredCategories" v-model="catsToSync">
                    <template slot-scope="props">
                        <strong v-text="getCategoryPath(props.option)"></strong> {{ props.option.name }}
                    </template>
                </b-taginput>
            </b-field>

        </div>

        <div class="section is-flex"  v-if="checkedRows.length">
            <b-button tag="button"
                      type="is-primary"
                      class="is-uppercase"
                      label="Update Products"
                      rounded style="margin-left: auto"
                      @click.prevent="submit"
                      outlined></b-button>
        </div>
    </div>
</template>
<script>
    import _ from "lodash";

    export default {
        props: {
            checkedRows: {
                required: true,
                type: Array
            },
        },
        data() {
            return {
                attributes: [],
                filteredCategories: [],
                spaceCategories: [],
                catsToSync: [],
                inputTypeMapping: {
                    string: 'text',
                    text: 'textarea'
                },
                input: {
                    store_ids: [1],
                    categories: {
                        toAdd: []
                    }
                },
                websites: [],
                loading: true
            }
        },
        created() {
            axios.get('/category/index')
                .then(response => {
                    this.filteredCategories = response.data
                    this.spaceCategories = response.data
                    this.loading = false;
                })
        },
        methods: {
            submit() {
                this.loading = true;
                this.input.product_ids = _.map(this.checkedRows, 'id').join(',')
                this.input.categories.toAdd = this.catsToSync;
                axios.patch('/product/mass/category', this.input)
                    .then(response => {
                        this.checkedRows = [];
                        this.$emit('update:checkedRows', this.checkedRows);
                        this.$buefy.snackbar.open({
                            message: response.data.message,
                            type: 'is-success',
                            position: 'is-bottom-right',
                            actionText: 'Ok',
                        })
                        this.$router.push({name: 'product.index'});
                        this.loading = false
                    })
                    .catch(error => {
                        this.$buefy.snackbar.open({
                            message: error.response.data.message,
                            type: 'is-success',
                            position: 'is-bottom-right',
                            actionText: 'Ok',
                        })
                        this.loading = false;
                    })
            },
            getCategoryPath(spaceCategory) {
                let path = spaceCategory.path.split('/')
                path.splice(-1,1);
                let prefix = ''
                for (let categoryId of path) {
                    let category = _.find(this.spaceCategories, {id: parseInt(categoryId)});
                    prefix += `${category.name} / `
                }
                return prefix;
            },
            getFilteredCategories(text) {
                this.filteredCategories = this.spaceCategories.filter((category) => {
                    return category.name
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
                })
            },
        },
        computed: {
            productIds() {
                return _.map(this.checkedRows, 'sku').join(', ')
            }
        }
    }
</script>
